<template lang="pug">
  div#mainnavi.container(:style="{ height: height + 'px' }")
    div.navibar-wrapper
      div.linear-bg
      div.desktop.navibar-container
        a.brand.clickable(@click="$router.push('/')")
          img.logo(:src= "logo" v-if="logoShow")
          span.name {{ brand }}
        ul.navibar
          li.navibar-item(v-for="(item, i) in items" :key="i" @click="navigate(item)" 
          :class="isItemActive(item.to)")
            img.icon(:src="item.svg")
            span.name {{ item.name }}
    div.banner#banner-carousel
      //- div#darth-fader(class="odo-carousel odo-carousel--fade" v-show="bannerShow")
      //-   div(class="odo-carousel__wrapper" :style="{ height: height + 'px' }")
      //-     div(class="odo-carousel__element")
      //-       div.odo-carousel__slide(v-for="banner in banners")
      //-         div(style="background-position:center center; background-size:cover; width: 100%; height: 100%;" :style="{ 'background-image': 'url(' + banner + ')' }")
      div#banner-cover(v-show="!bannerShow" style="background-position:center center; background-size:cover; width: 100%; height: 100%;" :style="bannerCoverStyle")
</template>

<script>
// @odopod/odo-carousel
import OdoCarousel from '@odopod/odo-carousel'
import '@odopod/odo-carousel/css/odo-carousel.css'
import '@odopod/odo-carousel/css/odo-carousel-theme.css'
import Coin from '@/components/commons/Coin'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      items: [
        { name: '首页', to: '/', svg: require('../../assets/icon-home.svg') },
        { name: '产品', to: '/product', svg: require('../../assets/icon-product.svg') },
        { name: '资讯', to: '/news', svg: require('../../assets/icon-news.svg') },
        { name: '公司', to: '/company', svg: require('../../assets/icon-company.svg') },
        { name: '我的', to: '/profile/basic', svg: require('../../assets/icon-mine.svg') }
      ],
      banners: [],
      slider: null,
      height: 480,
      bannerShow: false,
      bannerType: '',
      bannerCoverStyle: {}
    }
  },
  components: {
    OdoCarousel,
    Coin
  },
  watch: {
    '$route' (to, from) {
      if (this.site.web_index_img !== '') {
        this.modifyCoverStyle()
      }
    },
    'site.web_index_img' (newValue) {
      if (newValue !== '') {
        this.modifyCoverStyle()
      }
    }
  },
  computed: {
    ...mapState(['site']),
    brand () {
      return this.site.name
    },
    logo () {
      return this.mediaPath(`/media/${this.site.logo}`)
    },
    logoShow () {
      return this.site.logo !== ''
    }
  },
  mounted() {
    // const jpa = require('../../assets/a.jpg')
    // const jpb = require('../../assets/b.jpg')
    // const jpd = require('../../assets/d.jpg')
    // this.banners.push(...[jpa, jpb, jpd])
    // this.initSlider()
  },
  methods: {
    mediaPath (path) {
      return this.axios.defaults.baseURL + path
    },
    modifyCoverStyle () {
      const path = this.$route.path
      if (path === '/') {
        this.height = 480
        this.bannerShow = false
        this.bannerCoverStyle = {
          'background-image': 'url('+ this.mediaPath(`/media/${this.site['web_index_img']}`) +')'
        }
      } else {
        this.height = 410
        this.bannerShow = false
        if (path.indexOf('/company') >= 0) {
          this.bannerCoverStyle = {
            'background-image': 'url('+ this.mediaPath(`/media/${this.site['web_company_img']}`) +')'
          }
        } else if (path.indexOf('/profile') >= 0) {
          this.bannerCover = require('../../assets/c-2.jpg')
        } else if (path.indexOf('/news') >= 0) {
          this.bannerCoverStyle = {
            'background-image': 'url('+ this.mediaPath(`/media/${this.site['web_article_img']}`) +')'
          }
        } else if (path.indexOf('/product') >= 0) {
          this.bannerCoverStyle = {
            'background-image': 'url('+ this.mediaPath(`/media/${this.site['web_product_img']}`) +')'
          }
        }
      }
    },
    navigate (item) {
      if (item.to === '/') {
        document.title = this.site.name
      } else {
        document.title = item.name
      }
      this.$router.replace(item.to)
    },
    initSlider () {
      setTimeout(function () {
        if (!this.slider) {
          this.slider = new OdoCarousel(document.getElementById('darth-fader'), {
            isFade: true,
            isLooped: true,
            slideshowSpeed: 3750,
            animationSpeed: 1250,
            pagination: true,
            template: {
              paddleNextInner: '',
              paddlePrevInner: ''
            }
          })
        }
        this.slider.startSlideshow()
      }, 1000)
    },
    isItemActive (to) {
      const path = this.$route.path
      if (path === '/' && to === path) {
        return { 'active': true }
      } else {
        if (to === '/') {
          return { 'active': false }
        } else {
          const first = to.split('/').filter(t => t)[0]
          return { 'active': this.$route.path.indexOf(first) >= 0 }
        }
      }
    }
  }
}
</script>

<style scoped>
.container {
  /* height: 480px; */
  position: relative;
}

/* .odo-carousel__wrapper {
  height: 480px;
} */

.banner {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 0;
  overflow: hidden;
}

.navibar-wrapper {
  position: relative;
}

.navibar-container {
  color: white;
  z-index: 99;
  position: relative;
}

.linear-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 10;
  background: linear-gradient(1turn, #0000003b 1%, transparent, transparent);
}

.banner {
  position: absolute;
}

.brand {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.brand .logo {
  height: 40px;
  display: inline-block;
  vertical-align: middle;
}

.brand .name {
  font-size: 1.2rem;
  display: inline;
  vertical-align: middle;
  margin-left: 6px;
  font-weight: 400;
  text-shadow: 1px 1px 3px #a4a4a4;
}

.navibar {
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  text-align: right;
  list-style: none;
}

.navibar-item {
  display: inline-block;
  padding: 20px 30px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.navibar-item.active {
  border-bottom: 2px solid #d0121b;
  font-weight: bold;
}

 .navibar-item:hover {
  font-weight: bold;   
 }

.navibar-item .icon {
  vertical-align: middle;
  display: inline-block;
  width: 20px;
}

.navibar-item .name {
  display: inline;
  vertical-align: middle;
  padding-left: 5px;
  font-size: 1rem;
}
</style>





// WEBPACK FOOTER //
// src/components/commons/Navigator.vue